/**
 * A simple util to denormalize entities and ids into a single array
 * @param {string[]} ids The list of ids that serve as keys for entities
 * @param {object} entities Map of entity objects
 * @returns A denormalized array of entities containing the given ids
 */
export const denormalize = <
    Entity,
    EntitiesCollection extends Record<string, Entity>,
    IdsCollection extends keyof EntitiesCollection
>(
    ids: Array<IdsCollection>,
    entities: EntitiesCollection,
): Array<EntitiesCollection[IdsCollection]> => ids.map((id) => entities[id]);
